export default "__VITE_ASSET__ee912b77__"